module.exports = __webpack_public_path__ + "assets/logo-b.7a293a9e.svg";